import { datadogLogs } from '@datadog/browser-logs';
var DatadogLogger = /** @class */ (function () {
    function DatadogLogger() {
    }
    DatadogLogger.prototype.logToDatadog = function (method, message, context) {
        datadogLogs.logger[method](message, context);
    };
    DatadogLogger.prototype.log = function (message, context) {
        this.logToDatadog('log', message, context);
    };
    DatadogLogger.prototype.info = function (message, context) {
        this.logToDatadog('info', message, context);
    };
    DatadogLogger.prototype.warn = function (message, context) {
        this.logToDatadog('warn', message, context);
    };
    DatadogLogger.prototype.error = function (message, context) {
        this.logToDatadog('error', message, context);
    };
    return DatadogLogger;
}());
export { DatadogLogger };
